import React from 'react';
import PropTypes from 'prop-types';
import ContactTableCell from './ContactsTableCell';

const ContactsTable = ({
  contactFields = [],
  contacts = [],
  handleOpenViewModal,
  selectedListType,
}) => {
  if (!contacts.length) {
    return <p className="text-center text-gray-500">No contacts available.</p>;
  }

  return (
    <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
      <thead className="bg-gray-200">
        <tr>
          {contactFields.map((field) => (
            <th key={field.key} className="px-4 py-2 text-left font-bold text-sss-blue-sel">
              {field.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="text-gray-700">
        {contacts.map((contact) => (
          <tr key={contact.contactId || contact.id} className="border-t">
            {contactFields.map((field) => (
              <ContactTableCell
                key={`${contact.contactId || contact.id}-${field.key}`} // Make key unique
                field={field}
                contact={contact}
                handleOpenViewModal={handleOpenViewModal}
                selectedListType={selectedListType}
              />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

ContactsTable.propTypes = {
  contactFields: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  contacts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
  selectedListType: PropTypes.string.isRequired,
};

export default ContactsTable;
